import { computed, inject, Injectable, signal } from '@angular/core';
import { Dtos } from '#models';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class PaginationService<TData> {
  private _translateService = inject(TranslateService);
  private settings = signal<Dtos.PaginationSettings<TData>>({
    totalCount: 0,
    pageNumber: 1,
    pageSize: 10,
    currentPage: 1,
    items: [],
  });

  currentPage = computed(() => this.settings().currentPage);
  pageNumber = computed(() => this.settings().pageNumber);
  pageSize = computed(() => this.settings().pageSize);
  totalCount = computed(() => this.settings().totalCount);
  data = computed(() => this.settings().items);

  setPageNumber(page: number, first: number) {
    this.settings.update(v => ({ ...v, pageNumber: page, currentPage: first! }));
  }

  initialize(pageSize = 10) {
    this.settings.set({
      totalCount: 0,
      pageNumber: 1,
      currentPage: 1,
      items: [],
      pageSize,
    });
  }

  currentRange = computed(() => {
    return this._translateService.instant('paginator.currentPageReport', {
      currentInitialRow: (this.settings().pageNumber - 1) * this.settings().pageSize + 1,
      currentLastRow: this.settings().pageNumber * this.settings().pageSize,
      totalRecords: this.settings().totalCount,
    });
  });

  reset() {
    this.settings.update(pagination => ({
      ...pagination,
      items: [],
      totalCount: 0,
      pageNumber: 1,
      currentPage: 1,
    }));
  }

  build(items: TData[], totalCount: number) {
    this.settings.update(page => ({
      ...page,
      items,
      totalCount,
    }));
  }
}
